import BarChart from './BarChart.jsx';

function BusinessChart({ data }) {
  const options = {
    xaxis: {
      categories: [
        'Досуг, туризм и проживание',
        'Здоровье и красота',
        'Некоммерческие организации',
        'Еда и напитки',
        'Услуги для населения',
        'Розничная торговля',
        'Промышленность, строительство и B2B',
        'Финансы, право и страхование',
        'Образование (коммерческое)',
        'Авто и транспорт',
      ],
    },
  };

  const series = [
    {
      name: 'Количество',
      data,
    },
  ];

  return (
    <BarChart
      series={series}
      options={options}
      title="Количество бизнеса по типам, ед."
    />
  );
}

export default BusinessChart;
